<template>
  <div class="content-container">
    <search-comp @onSearch="onSearch" @onReset="onResetSearch">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Tên chương trình' }}
                </div>
                <div class="">
                  <input type="text" placeholder="selectwithsearch" />
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Người phụ trách' }}
                </div>
                <div class="">
                  <input type="text" placeholder="selectwithsearch" />
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Nền tảng' }}
                </div>
                <div class="">
                  <input type="text" placeholder="selectwithsearch" />
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Thời gian' }}
                </div>
                <div class="">
                  <CalendarSelect mode="date" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>

    <div class="content-box">
      <div class="section-box outline">
        <div class="das-form-container">
          <div class="das-form-title-container" style="display: flex">
            <div class="das-form-title">
              <span class="main-title">
                {{ `Báo cáo doanh thu từ quảng cáo` }}
              </span>
            </div>

            <DownloadBtn @openNoteDialog="dialogNoteVisible = true" />
          </div>
          <hr />

          <div class="grid-scroll mt-10">
            <GridVx
              ref="agGrid"
              :columns="columns"
              :rows="rows"
              class="agGrid"
            />
          </div>
        </div>
      </div>
    </div>

    <NoteDialog v-model="dialogNoteVisible">
      <div class="das-form-container">
        <div class="das-form-group">
          <ul class="annotate-container">
            <li>
              - Tên chương trình: Tên chương trình được chạy quảng cáo trên nền
              tảng
            </li>
            <li>
              - Thời gian quảng cáo: Hiển thị thời gian chạy quảng cáo dưới dạng
              Từ ngày - Đến ngày: Format: DDMMYYYY- DDMMYYYY
            </li>
            <li>- Chi phí: Hiển thị chi phí cho quảng cáo trên nền tảng</li>
            <li>
              - Người phụ trách: hiển thị tên người phụ trách quảng cáo trên nền
              tảng trong thời gian tìm kiếm
            </li>
            <li>- Lượng click: Số lượng lượt Click vào đường link Quảng cáo</li>
            <li>
              - Lượng View/Like/Comment/Share: Hiển thị số lượng tương tác đối
              với bài quảng cáo dưới dạng x/y/z/v tương ứng với số lượng lượt
              view (đối với video) / Số lượng lượt like/ Comment/Share của bài
              quảng cáo
            </li>
            <li>
              - Lượng quan tâm: số lượng người đã ấn quan tâm trên nền tảng
              trong thời gian quảng cáo
            </li>
            <li>
              - Lượng đặt phòng: Lượng đặt phòng qua link quảng cáo trên nền
              tảng
            </li>
            <li>
              - Tỷ lệ chuyển đổi: Hiển thị Lượng người đặt phòng thành công/
              Tổng lượng người truy cập vào post quảng cáo *100. Đơn vị %
            </li>
            <li>
              - Doanh thu: Tổng số doanh thu của tất cả người dùng đặt qua link
              quảng cáo
            </li>
            <li>
              - Tổng: Hiển thị tổng chi phí, doanh thu, lượt tương tác của tất
              các chương trình quảng cáo trên 1 nến tảng
            </li>
            <li>
              - Tổng cộng : Hiển thị tổng chi phí, doanh thu, lượt tương tác của
              tất các chương trình quảng cáo trên tất cả nến tảng
            </li>
            <li>***Lưu ý:</li>
            <li>- Mỗi nền tảng hiển thị 1 bảng</li>
            <li>- Lấy dữ liệu từ thống kê của nền tảng được chạy quảng cáo</li>
          </ul>
        </div>
      </div>
    </NoteDialog>
  </div>
</template>

<script>
import DownloadBtn from '../components/DownloadBtn.vue'
import NoteDialog from '../components/NoteDialog.vue'
import CalendarSelect from '@/components/CalendarSelect/CalendarSelect.vue'

export default {
  components: { DownloadBtn, NoteDialog, CalendarSelect },
  data() {
    return {
      // date
      date: {
        start: null,
        end: null
      },

      // grid => use colspan
      columns: [
        { headerName: 'Tên chương trình', field: '' },
        { headerName: 'Thời gian quảng cáo', field: '' },
        { headerName: 'Chi phí', field: '' },
        { headerName: 'Doanh thu', field: '' },
        { headerName: 'Người phụ trách', field: '' },
        { headerName: 'Lượng click', field: '' },
        { headerName: 'Lượng View/Like/Comment/Share', field: '' },
        { headerName: 'Lượng quan tâm', field: '' },
        { headerName: 'Lượng đặt phòng', field: '' },
        { headerName: 'Tỷ lệ chuyển đổi', field: '' }
      ],
      rows: [],

      // dialog
      dialogNoteVisible: false
    }
  },
  methods: {
    onSearch() {},
    onResetSearch() {}
  }
}
</script>
